import { AppName } from "@remi/enums/app-name";

import { api } from "~/utils/api";

export const useAppSettings = () => {
  return api.config.getAppSetting.useQuery(AppName.NEXTJS, { refetchInterval: 1000 * 60 });
};
